import * as Yup from 'yup';

export default Yup.object().shape({
    phoneNumber: Yup.string().min(6, 'Invalid number').required('Phone number is required'),
    countryCode: Yup.string().required('Required'),
});
